import React, { useState } from "react";
import { motion } from "framer-motion";
// import Layout from '../layout/Layout'
// import Announcement from "../components/Ecosystem/Announcement";
// import Subscribe from "../components/app/big/Subscribe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

const team1 = "../images/teams/team1.png";
const team2 = "../images/teams/team2.png";
const team3 = "../images/teams/team3.png";
const team4 = "../images/teams/team4.png";
const team5 = "../images/teams/team5.png";

const Team = () => {
  const teams = [
    {
      img: team1,
      name: "Adebisi Osademe ",
      title: " Co-founder",
      twitter: "/",
      linkedn: "/",
    },
    {
      img: team2,
      name: "Filip Ocenas",
      title: "Co-founder",
      twitter: "/",
      linkedn: "/",
    },
    {
      img: team3,
      name: "Tosin Osajuigbe",
      title: " Head of Operations",
      twitter: "/",
      linkedn: "/",
    },
    {
      img: team4,
      name: "Emmanuel Epiot",
      title: " Marketing Lead",
      twitter: "/",
      linkedn: "/",
    },
    {
      img: team5,
      name: "Vishal Petigara",
      title: " Legal Advisor",
      twitter: "/",
      linkedn: "/",
    },
  ];
  return (
    <section id="teamsection" className="section wf-section">
      <div className="container">
        <div className="teamcontainer">
          <div className="meettitle">
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              <span className="color-text-gradient">Meet The Team</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-[#ffffffa3] text-center text-style-all-caps"
            >
              Meet our core team members
            </motion.p>
          </div>

          <div className="teaminnerdiv">
            {teams.map(({ img, name, title, twitter, linkedn }, index) => (
              <motion.div
                initial={{ y: 50 }}
                whileInView={{ y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                className=" "
                key={index}
              >
                <img className="teampic transform transition duration-500 hover:scale-110 hover:translate-y-2 hover:-rotate-3" src={img} alt={name} />
                <div className=" mb-5 text-center">
                  <p className="font-semibold mt-3 ">{name}</p>
                  <p>{title}</p>
                  <div className="flex gap-3 justify-center text-base mt-4">
                    <a href={twitter} target="blank">
                      <FontAwesomeIcon icon={faTwitter} />{" "}
                    </a>
                    <a href={linkedn} target="blank">
                      {" "}
                      <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
